import { useMemo } from "react";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";
import type { IssueTypeWithFields } from "#app/components/issue-view/issue-view-types";

/**
 * The workspace's issue types with each field binding resolved to its custom
 * field definition — the shape the migrate dialog and the detail view's
 * custom-fields table read. Joins the two always-on workspace pools; a binding
 * whose field is gone (deleted field, stale type) resolves to `null`.
 */
export function useIssueTypesWithFields(): IssueTypeWithFields[] {
  const { customFields, issueTypes } = useWorkspaceData();
  return useMemo(() => {
    const fieldsById = new Map(
      customFields.map((field) => [field.customFieldId, field]),
    );
    return issueTypes.map((issueType) => ({
      ...issueType,
      fields:
        issueType.fields?.map((binding) => ({
          ...binding,
          field: fieldsById.get(binding.customFieldId) ?? null,
        })) ?? null,
    }));
  }, [customFields, issueTypes]);
}
